import { Dialog, ProgressIndicator } from '@dnb/eufemia';
import type { JSX } from 'react';

export default function LoadingModal(): JSX.Element {
  return (
    <Dialog alignContent="centered" hideCloseButton maxWidth="18rem" noAnimation omitTriggerButton open preventClose>
      <ProgressIndicator
        bottom="large"
        labelDirection="vertical"
        showDefaultLabel
        size="medium"
        top="large"
        type="linear"
      />
    </Dialog>
  );
}
